import bizNodeModel from '../../bizNodeModel.mjs'

export default bizNodeModel({
    dpSn: {
        name: () => '软件SPEC单编号',
        readOnly: () => true,
    },

    isrfName: {
        name: () => '标题',
        required: () => true,
    },

    memo: {
        name: () => '简述',
    },

    reqNo: {
        name: () => '业务需求单编号',
    },
})
